import {useQuery, gql} from "@apollo/client";
import {useContext} from "react";
import {LocaleContext} from "../store/providers/LocaleProvider";
import {useLogger} from "./useLogger";

const QUERY = gql`
query getApartmentImages($hapimagResortId: Int!, $locale: String!, $apartmentCode: String ) {
    resortApartmentCategoryCollection(where: {resort: {hapimagResortId: $hapimagResortId}, apartmentCategory:{apartmentCode:$apartmentCode}}, locale: $locale,order:title_ASC) {
        items {
            title,
            apartmentCategory {
                apartmentCode,
                wheelchairAccessible,
                apartmentSize {
                    sizeNaming
                },
                apartmentNaming {
                    title
                },
                maximumNumberOfGuests,
                extraBedPossible
            },
            apartmentImagesCollection {
                items {
                    title,
                    url,
                    sys {
                        id
                    }
                }
            },
            sys {
                id
            }
        }
    }
}
`;

export const useApartmentImages = (hapimagResortId, apartmentCode) => {
    const {localeUppercase} = useContext(LocaleContext)[0];
    const {logger} = useLogger();
    const {loading, error, data} = useQuery(QUERY, {
        variables: { hapimagResortId, locale: localeUppercase, apartmentCode },
        errorPolicy: "all"
    });
    const apartments = data?.resortApartmentCategoryCollection?.items;

    if (error?.message) {
        logger(error?.message, "error", "useApartmentImages", error?.stack);
    }

    return {
        apartments,
        loading,
        error
    };
};
